import { DetectedWebView, detectWebView } from "@ciaopeople/cp-shatsu/ClientDetection";
import { PostMessageProxyPromise } from "@ciaopeople/cp-shatsu/RemoteService";
import { FBManualFlowCommons } from "./FBManualFlowCommons.js";
import { CookieChangeEventData, SessionStorageInterface } from "../../../session/SessionStorageInterface.js";
import { Emitter } from "@ciaopeople/cp-shatsu/Queues";
import { CookieNamesConfig } from "../../../config/PropertyConfig.js";
import { ActualDataTuple, LoginError, LoginErrorCodes, ThirdPartyCientAuthData } from "../../data/LoginData.js";
import { PromiseOnSteroids } from "@ciaopeople/cp-shatsu/PromiseOnSteroids";
import { debug } from "../../LoginDbg.js";
import { tryToPromise } from "../../../shared.js";
import { encodeFBStateParam } from "./FBStateParam.js";

enum PROMPT_MODE  {
    POPUP = 0,
    REDIRECT = 1
}
class FacebookManualFlowLocalPart extends FBManualFlowCommons {
   
   

    private detectedWebview: DetectedWebView;
    private fbTokenChangeEmitter: Emitter<CookieChangeEventData>;

    constructor(private readonly proxy: PostMessageProxyPromise,
        private readonly sessionStorage: SessionStorageInterface,
        private readonly cookieNames: CookieNamesConfig,
        public readonly appId: string, 
        public readonly redirectUrl: string,
        scopes: string[] = []) {

        super(scopes);
        this.proxy.register(this.proxyMethodNames.promptLogin, () => this.promptLogin());
        this.proxy.register(this.proxyMethodNames.oneTapLogin, () => this.oneTapLogin());
        this.detectedWebview = detectWebView();
        this.fbTokenChangeEmitter = new Emitter<CookieChangeEventData>();
        this.sessionStorage.onCookieChange((ch) => {
            
            
            debug.write("Cookie changed emitting:", ch);
            if(ch.name == "fbToken") {
                this.fbTokenChangeEmitter.emit(ch);
            }
                
        });
        
    }

    preloadAction(): Promise<void> {
        return Promise.resolve();
    }


    private getNextFbTokenCookieChange(): Promise<CookieChangeEventData> {
        const nextProm = this.sessionStorage.clearFacebookLoginToken().then(() =>{
            debug.write("getNextFbTokenCookieChange" );
            return this.fbTokenChangeEmitter.next();
        });
        this.sessionStorage.startCookieMonitoring('fbToken');
        return nextProm.then(res => {
            this.sessionStorage.stopCookieMonitoring('fbToken');
            return res;
        });
    }

    

    getSessionDataForAutologin(): Promise<ThirdPartyCientAuthData> {
        return this.proxy.invoke(this.proxyMethodNames.getSessionDataForAutologin);
    }
    promptLogin(): Promise<ThirdPartyCientAuthData> {
        const useMode = this.detectedWebview.browser.webview &&
                            this.detectedWebview.extra.isFacebook?PROMPT_MODE.REDIRECT:PROMPT_MODE.POPUP;
        const isModePopup = this.detectedWebview.browser.webview && this.detectedWebview.extra.isFacebook ? false : true;

        // const isModePopup = false;
        // const useMode = PROMPT_MODE.REDIRECT;
        


        const nextUrl = this.getLoginDialogUrl(useMode);
        if(isModePopup) {
            const width = 500;
            const height = 600;
            const left = Math.floor((screen.width - width) / 2);
            const top = Math.floor((screen.height - height) / 2);
            const windowSettings: string[][] = [
                ["width", width +""],
                ["height", height + ""],
                ["top", top + ""],
                ["left", left + ""],
                ["location", "no"],
                ["menubar", "no"],
                ["toolbar", "no"]
            ];

            const serializedSettings = windowSettings.
                map(kv => kv.join("=")).join(",");
            
            const popupWindow: Window = window.open(nextUrl, 'fbMFLogin', serializedSettings);
            if(popupWindow) {
                
                const nextChange = this.getNextFbTokenCookieChange();
                PromiseOnSteroids.windowClosePromise(popupWindow).then( 
                    _x => PromiseOnSteroids.timeout(1000, null).then(
                        _y => {
                            debug.write("Checking login token login on popup close (timeout)");
                            return this.sessionStorage.getFacebookLoginToken().then(
                                tok => {
                                    if (tok == "") {
                                        debug.write("Clearing facebook login on popup close (timeout)");
                                        this.sessionStorage.cancelFacebookLogin();
                                    }
                                    return null;
                                }
                            );
                        }
                    )
                );
                return nextChange.then(res => {
                    debug.write("nextChange ", res);
                    if(res.val == "cancel") {
                        return Promise.reject(new LoginError(LoginErrorCodes.LOGIN_CANCELED, "Login Canceled by the user"));
                    }
                    else {
                        return tryToPromise(
                            () => {
                                return new ThirdPartyCientAuthData(
                                    null,
                                    new ActualDataTuple(this.providerId, res.val)
                                );
                            },
                            e =>  new LoginError(LoginErrorCodes.UNSPECIFIED_ERROR, "Invalid auth data", e)
                        );
                    }
                });
            }
            else {
                debug.write("Cannot open FB popup -- maybe popups are blocked");
                return Promise.reject(new LoginError(LoginErrorCodes.UNSPECIFIED_ERROR, "Popups are blocked"));
            }
            
        }
        else {
            window.location.href = nextUrl;
            return PromiseOnSteroids.timeout(3000, null);
        }
    }
    oneTapLogin(): Promise<ThirdPartyCientAuthData> {
        return Promise.reject(new LoginError(LoginErrorCodes.UNSPECIFIED_ERROR, "Unsupported function in Facebook"));
    }
    eventuallyHandleRevoke(hint: string, isDeleteRequest: boolean): Promise<boolean> {
        return this.proxy.invoke(this.proxyMethodNames.eventuallyHandleRevoke, hint, isDeleteRequest);
    }


    private getLoginDialogUrl(mode: PROMPT_MODE) {
        const isMobile = this.detectedWebview.device.phone || this.detectedWebview.device.tablet;
        const hostPrefix = isMobile?"m":"www";
        
        const state:string = encodeFBStateParam({
            u: document.location.href,
            m: (mode == PROMPT_MODE.POPUP?"popup":"redirect")
        });
       
        const pArr: string[][] =  [
            ["client_id", this.appId],
            ["redirect_uri", this.redirectUrl],
            ["state", state],
            ["scope", this.useScopes.join(",")]
        ];
        if(mode == PROMPT_MODE.POPUP) {
            pArr.push(["display", "popup"]);
        }
        const qstring = pArr.map(e => e[0]+ "=" + encodeURIComponent(e[1])).join("&");

        return `https://${hostPrefix}.facebook.com/v15.0/dialog/oauth?${qstring}`;
    }

}
export { FacebookManualFlowLocalPart };